export const initialState = {
    dashboardData: {},
    adsData: {},
    isActiveSeller: false
};

export const urls = {
    sellerData: userId => `/api/seller-details/${userId}/?format=json`,
    adsData: (pageIndex, userId) => `/api/seller-ads/${userId}/?page=${pageIndex + 1}&format=json`,
    activeSellers: userId => `/api/active-seller/${userId}/`
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'RECEIVE_DASHBOARD_DATA':
            return {
                ...state,
                dashboardData: action.data
            };
        case 'RECEIVE_DASHBOARD_ADS_DATA':
            return {
                ...state,
                adsData: action.data
            };
        case 'RECEIVE_ACTIVE_SELLERS':
            return {
                ...state,
                isActiveSeller: action.data
            };
        default:
            return state;
    }
};
